import { DeepPartial } from '@apollo/client/utilities'
import { ShiftManagementSwapShiftApprovableMetadataFragment } from 'generated/resources/graphql'

import { formatShiftTime } from './helpers'

const normalizeShift = (
  shift: DeepPartial<ShiftManagementSwapShiftApprovableMetadataFragment['currentShift']>
) => {
  if (!shift || !shift.name || !shift.startAt || !shift.endAt) {
    return
  }

  return `${shift.name} (${formatShiftTime(shift.startAt, shift.endAt)})`
}

export const getShiftManagementSwapShiftMetadata = (
  data: DeepPartial<ShiftManagementSwapShiftApprovableMetadataFragment>
) => {
  if (!data.currentShift || !data.requestedShift) {
    return []
  }

  return [normalizeShift(data.currentShift), normalizeShift(data.requestedShift)].filter(Boolean)
}
